export default [
  {
    path: '/main/bankaccounts',
    meta: {
      tag: 'list_bankaccount',
      name: 'Contas Bancárias',
      breadcrumb: 'Contas Bancárias'
    },
    component: () => import(/* webpackChunkName: "users-list" */ '@/views/main/settings/test-registers/bankaccount/Index.vue'),
    children: [
      {
        path: '',
        name: 'listbankaccounts',
        meta: {
          tag: 'list_bankaccount',
          menu: 'settings',
          name: 'Contas Bancárias'
        },
        component: () => import(/* webpackChunkName: "users-list" */ '@/views/main/settings/test-registers/bankaccount/List.vue')
      },
      {
        path: '/main/bankaccount/add',
        name: 'addbankaccount',
        meta: {
          tag: 'add_bankaccount',
          menu: 'settings',
          name: 'Adicionar | Contas Bancárias',
          breadcrumb: 'Adicionar Conta Bancária'
        },
        component: () => import(/* webpackChunkName: "users-add" */ '@/views/main/settings/test-registers/bankaccount/Add.vue')
      },
      {
        path: '/main/bankaccount/:id',
        name: 'editbankaccount',
        meta: {
          tag: 'edit_bankaccount',
          menu: 'settings',
          name: 'Editar | Conta Bancária',
          breadcrumb: 'Editar Conta Bancária'
        },
        component: () => import(/* webpackChunkName: "users-edit" */ '@/views/main/settings/test-registers/bankaccount/Edit.vue')
      }
    ]
  },
]
